/* PROGYM SWISS — precise, minimal motion. No scale/bounce/float. */
(function () {
  "use strict";

  var root = document.documentElement;
  var KEY = "progym-motion";

  /* ---- Reduce-motion master toggle -------------------------------- */
  function applyMotion(state) {
    root.setAttribute("data-motion", state);
    document.querySelectorAll("[data-motion-toggle]").forEach(function (b) {
      b.setAttribute("aria-pressed", state === "off");
      b.textContent = state === "off" ? "Motion: Off" : "Motion: On";
    });
  }
  var saved = null;
  try { saved = localStorage.getItem(KEY); } catch (e) {}
  var prefersReduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  applyMotion(saved || (prefersReduce ? "off" : "on"));

  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-motion-toggle]");
    if (!t) return;
    var next = root.getAttribute("data-motion") === "off" ? "on" : "off";
    applyMotion(next);
    try { localStorage.setItem(KEY, next); } catch (err) {}
  });

  var motionOff = function () { return root.getAttribute("data-motion") === "off"; };

  /* ---- Mobile nav ------------------------------------------------- */
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-nav-toggle]");
    if (!b) return;
    var nav = document.getElementById(b.getAttribute("aria-controls"));
    if (!nav) return;
    var open = nav.classList.toggle("is-open");
    b.setAttribute("aria-expanded", open);
  });

  /* ---- Scroll reveal: fade + rise + divider draw ------------------ */
  function reveal() {
    var els = document.querySelectorAll(".rise, .divider");
    if (motionOff() || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        // tight stagger for grouped children
        var group = el.closest("[data-stagger]");
        if (group && !group.__staggered) {
          group.__staggered = true;
          Array.prototype.forEach.call(group.children, function (child, i) {
            child.style.setProperty("--d", (i * 40) + "ms");
            child.classList.add("is-in");
          });
        } else {
          el.classList.add("is-in");
        }
        io.unobserve(el);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Article progress bar -------------------------------------- */
  function progress() {
    var bar = document.querySelector(".progress__bar");
    if (!bar) return;
    var raf = null;
    function update() {
      raf = null;
      var doc = document.documentElement;
      var h = doc.scrollHeight - doc.clientHeight;
      var p = h > 0 ? Math.min(1, Math.max(0, doc.scrollTop / h)) : 0;
      bar.style.transform = "scaleX(" + p + ")";
    }
    window.addEventListener("scroll", function () {
      if (raf) return;
      raf = requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  function init() { reveal(); progress(); }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
